module.exports = __webpack_public_path__ + "assets/img/index4_15.44702e6b.jpg";